/* eslint-disable no-restricted-imports */
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import { ACCOUNT_TABS } from '@/components/content/Account/parts/Tabs';
import {
	AccountSummaryLinkButtonSX,
	AccountSummaryTitleSX,
} from '@/components/content/Account/styles/summary';
import { AccountSummaryCardPoints } from '@/components/content/Account/parts/AccountSummaryCardPoints';
import { useNotifications } from '@/data/Content/Notifications';
import { ClubdpCards } from 'integration/generated/transactions/data-contracts';
import { AccountSummaryLinkToCard } from './SummaryLinkToCard';
import { AccountSummaryLinkToCardDppointsForm } from '@/components/content/Account/parts/AccountSummaryLinkToCardDppointsForm';
import { useIsOpen } from 'integration/hooks/useIsOpen';
import { ShowByCondition } from '@/components/blocks/ShowByCondition';

interface AccountSummaryDpvaleProps {
	rawData?: ClubdpCards;
	onSelectedTab: (tab: ACCOUNT_TABS) => void;
}

export const AccountSummaryDpvale: React.FC<AccountSummaryDpvaleProps> = ({
	rawData,
	onSelectedTab,
}) => {
	const handleTabRewards = () => {
		window.open('/dpvale', '_blank');
	};

	const openForm = useIsOpen();

	const { showSnackbarMessage } = useNotifications();

	const handleOnCopy = () => {
		const last4Digits = rawData?.cards.puntosDpVale?.last4Digits;
		if (last4Digits) {
			navigator.clipboard.writeText(last4Digits);
			showSnackbarMessage('Copiado al portapapeles');
		}
	};

	return (
		<Box>
			<Typography component={'h2'} sx={AccountSummaryTitleSX}>
				{'CLUB DPPUNTOS DP VALE'}
			</Typography>
			{rawData?.linked.puntosDpVale ? (
				<Stack spacing={2}>
					<AccountSummaryCardPoints
						type="dpvale"
						balancePoints={rawData?.cards.puntosDpVale?.balancePoints || '0'}
						last4Digits={rawData?.cards.puntosDpVale?.last4Digits || '0000'}
						fullCardNumber={rawData?.cards.rewards?.cardId || ''}
						onCopyCard={handleOnCopy}
					/>
					<ButtonBase sx={AccountSummaryLinkButtonSX} disableRipple onClick={handleTabRewards}>
						{'Actualizar información'}
					</ButtonBase>
				</Stack>
			) : (
				<AccountSummaryLinkToCard
					type="dpvale"
					title="¿TIENES TARJETA CLUBDPPUNTOS?"
					description="Vincula tu tarjeta y canjea tus puntos"
					img="/images/clubdppuntos-logo.png"
					onLinkToCard={openForm.on}
				/>
			)}
			<ShowByCondition condition={openForm.open}>
				<AccountSummaryLinkToCardDppointsForm
					onClose={openForm.off}
					onGoToClubDppoints={() => onSelectedTab(ACCOUNT_TABS.CLUBDP_POINTS)}
				/>
			</ShowByCondition>
		</Box>
	);
};
